import axios from 'axios'
import { env } from '@ivy/fts/envInfo/envInfo'
import config from '../../config'
class Statisctics {
  aplus_queue = window['aplus_queue'] || []
  userInfo: any = {}
  constructor() {}
  async init() {
    let appKey =
      config.env === 'production'
        ? '6197576ee014255fcb8384dc'
        : '61974aeee014255fcb83334b'
    if (window.location.host.indexOf('.simulate') >= 0) {
      appKey = '61974aeee014255fcb83334b'
    }
    await env.init()
    this.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', appKey],
    })
    this.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-waiting', 'MAN'],
    })
    this.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['enableVerify', true],
    })
    this.userInfo = await env.getInfo()
  }

  /**
   * 自定义事件埋点
   * @param eCode 事件编码
   * @param eType 事件类型
   * @param eParams 事件参数对象
   * @param mapper 友盟及内部埋点对应规则
   * @param config 扩展配置
   *   内部埋点表和eParams中参数对应关系 例：[[p1, id]]
   *   支持参数拼接 例：[[p1, id_name]] 上报数据为 p1: 01_张三
   */
  async sendRecord(eCode, eType, eParams, mapper, config?) {
    try {
      const params = await this.getParams(eParams, config)
      if (env.type === 'ivydad') {
        try {
          await env.logAttributes({ event: eCode, attrs: { ...params } })
        } catch (e) {
          console.log('ERROR, 当前APP版本暂不支持该埋点事件')
        }
      } else {
        this.aplus_queue.push({
          action: 'aplus.record',
          arguments: [eCode, eType, params],
        })
      }
      await this.addStatistics({
        event_type: eCode,
        ...this.mapParams(params, mapper),
      })
      return { status: 'SUCCESS' }
    } catch (e) {
      return { status: 'ERROR', message: e }
    }
  }

  /**
   * 页面曝光埋点
   * @param eCode 事件编码
   * @param eType 事件类型
   * @param eParams 事件参数对象
   * @param mapper 友盟及内部埋点对应规则
   * @param config 扩展配置
   */
  async sendPV(eCode, eType, eParams, mapper, config?) {
    try {
      if (env.type === 'ivydad') {
        try {
          await env.logPageExposure(eParams.PageName || '')
        } catch (e) {
          console.log('ERROR, 当前APP版本暂不支持该埋点事件')
        }
      } else {
        const params = await this.getParams(eParams)
        this.aplus_queue.push({
          action: 'aplus.sendPV',
          arguments: [{ is_auto: false }, params],
        })
        await this.addStatistics({
          event_type: eCode,
          ...this.mapParams(params, mapper),
        })
      }
      return { status: 'SUCCESS' }
    } catch (e) {
      return { status: 'ERROR', message: e }
    }
  }

  async getParams(params, config?) {
    let UserId, VipType, UserType
    if (env.type === 'ivydad') {
      UserId = +this.userInfo.userInfo.memId
      VipType = +this.userInfo.userInfo.isVip ? '会员' : '非会员'
      if (params.FromPage) {
        let FromPage = ''
        try {
          let nameType =
            config && config.useCurPageName
              ? 'getCurrentPageName'
              : 'getPrePageName'
          let res = await env[nameType]()
          if (typeof res === 'string') {
            res = JSON.parse(res)
          }
          FromPage =
            res.pageName ||
            { getCurrentPageName: '首页', getPrePageName: '' }[nameType]
        } catch (e) {
          console.log('ERROR, 当前APP版本暂不支持该埋点事件')
        }
        params.FromPage = FromPage
      }
    } else {
      UserId =
        (this.userInfo.logined &&
          this.userInfo.logined.user &&
          this.userInfo.logined.user.id) ||
        0
      VipType =
        this.userInfo.logined && this.userInfo.logined.vip ? '会员' : '非会员'
      if (params.FromPage) params.FromPage = document.referrer || ''
    }
    UserType = UserId ? '注册用户' : '游客'
    return { ...params, UserId: UserId.toString(), VipType, UserType }
  }

  mapParams(params, mapper) {
    if (!mapper) return params
    let mObj = {}
    for (let m of mapper) {
      mObj[m[0]] = m[1]
        .split('_')
        .filter(el => el)
        .reduce((t, c, i) => {
          return i === 0 ? t + params[c] || '' : t + '_' + params[c] || ''
        }, '')
    }
    return mObj
  }

  async addStatistics(params) {
    let requestConfig: any = {
      disableLoading: true,
      disableAlert: true,
      disableNetWorkError: true,
    }
    if (env.type === 'ivydad') {
      await axios.get('/api/stat/upload/eventNew', {
        params: {
          event: params.event_type,
          app_version: this.userInfo.publicParams.version,
          mem_id: +this.userInfo.userInfo.memId || 0,
          ...params,
          ...this.userInfo.publicParams,
          client_time: new Date(),
        },
        ...requestConfig,
      })
    } else {
      await axios.get('/api/stat/upload/activity', {
        params: {
          ...params,
          ...this.userInfo.publicParams,
          activity_table: 'shopping',
        },
        ...requestConfig,
      })
    }
  }
}

export const uploadEvent = new Statisctics()

/**
 * 跳转配置url解析
 * @param url 需要解析的跳转url
 * @param type url类型
 * @returns
 */
export async function translateUrl(url) {
  let translateRes: any = {}
  try {
    let jumpType = 'h5'
    let jumpName = ''
    let jumpId = ''
    let isAppWeex = url.includes('ivydadreadtool')
    if (isAppWeex) {
      let requestConfig: any = {
        disableLoading: true,
        disableAlert: true,
        disableNetWorkError: true,
      }

      // 获取跳转配置信息
      let appUrlSetting
      if (window.sessionStorage.getItem('_app_url_setting')) {
        appUrlSetting = JSON.parse(
          window.sessionStorage.getItem('_app_url_setting')
        )
      } else {
        let { data: settingInfo } = await axios.get(
          `/api/mobile/other/setting/getSetting?cat=ADMIN&key=app_url`,
          {
            ...requestConfig,
          }
        )
        appUrlSetting = settingInfo
        window.sessionStorage.setItem(
          '_app_url_setting',
          JSON.stringify(appUrlSetting)
        )
      }

      let path = url
        .split('://')[1]
        .split('?')[0]
        .split('/')

      // 微页面路径特殊处理
      if (path[0] === 'commonwebpage') {
        path = [path[0]]
      }

      // 解析路径
      let resovledPath = deepSearchPath([...path], appUrlSetting)
      console.log('resovledPath', resovledPath)
      jumpType = resovledPath.reduce((t, c) => (t ? t + '/' + c : c), '')

      // 获取参数信息
      let { data: paramsSetting } = await axios.get(
        '/api/mobile/other/setting/getParams',
        {
          params: { value: path, data2Array: 1 },
          ...requestConfig,
        }
      )

      // 解析参数
      let params = []
      let queryParams = url.split('?')
      if (queryParams.length > 1) {
        queryParams[1].split('&').map(el => {
          params.push(el.split('='))
        })
      }

      let resolvedParams = getParamLabel(params, paramsSetting)

      // 需要特殊处理的参数
      let specialList = ['id', 'course_id', 'spuId', 'tid', 'page_id']

      for (let el of params) {
        let [key, value] = el
        if (specialList.includes(key)) {
          jumpId = jumpId ? jumpId + '/' + value : value
        }

        // word参数放到jumpName中
        if (key === 'word') {
          resolvedParams.push(value)
        }
      }
      console.log('resolvedParams', resolvedParams)
      jumpName = resolvedParams.reduce((t, c) => (t ? t + '/' + c : c), '')
    } else {
      jumpName = url
    }

    translateRes = {
      jumpType,
      jumpName,
      jumpId,
    }
  } catch (e) {
    console.log('链接解析错误', e)
  }
  return translateRes
}

function deepSearchPath(paths, origin) {
  if (!paths.length || !origin.length) return []
  let cur = origin.find(el => el.value === paths[0])
  if (cur) {
    return [cur.label, ...deepSearchPath(paths.slice(1), cur.children || [])]
  } else {
    return []
  }
}

function getParamLabel(params, setting) {
  if (!params.length || !setting.length) return []
  let res = []
  params.forEach(el => {
    if (el.length !== 2) return
    let cur = setting.find(curEl => curEl.name === el[0])
    if (cur) {
      for (let curData of cur.data) {
        if (curData[0] === el[1]) {
          res.push(curData[1])
          break
        }
      }
    }
  })
  return res
}
